import MainPageCommonService from "../../../../services/main-page/MainPageCommonService";
import gsap from "../../../../helpers/gsapInstance";
import AsyncHelper from "../../../../helpers/AsyncHelper";
import MainPageFifthScreenCommon from "./MainPageFifthScreenCommon";

export default class MainPageFifthScreenDesktop extends MainPageCommonService {
    private readonly $holder: JQuery;

    public readonly $screen: JQuery;
    public readonly $screenContainer: JQuery;
    public readonly $topContent: JQuery;
    public readonly $bottomContent: JQuery;
    public readonly $circleCenterPoint: JQuery;
    public readonly $cards: JQuery;

    constructor($holder: JQuery) {
        super();

        this.$holder = $holder;

        const selectors = MainPageFifthScreenCommon.selectors;
        this.$screen = this.$holder.find(selectors.screen);
        this.$screenContainer = this.$screen.find(selectors.screenContainer);
        this.$topContent = this.$screenContainer.find(selectors.topContent);
        this.$bottomContent = this.$screenContainer.find(selectors.bottomContent);
        this.$circleCenterPoint = this.$screenContainer.find(selectors.circleCenterPoint);
        this.$cards = this.$screenContainer.find(selectors.cards);

        this.setDefaultProps = this.setDefaultProps.bind(this);
        this.setShowScreenAnimation = this.setShowScreenAnimation.bind(this);
        this.setHideScreenAnimation = this.setHideScreenAnimation.bind(this);
    }

    /**
     * Задать дефолтные значения для кругов при переходе на экран
     * @public
     */
    public setDefaultProps() {
        if (this.$circleCenterPoint.hasClass(this.ACTIVE_CLASS)) {
            this.$circleCenterPoint.removeClass(this.ACTIVE_CLASS);
        }
    }

    /**
     * Задать анимацию на появление 5 экрана
     * @public
     */
    public async setShowScreenAnimation() {
        /**
         * здесь мы двигаем $topContent и $bottomContent
         * по оси Y с 100px на дефолтное состояние в 0,
         * и с opacity 0 по 1
         */
        gsap.fromTo([
            this.$topContent, this.$bottomContent
        ], {
            transform: `translate(0px, ${100}px)`,
            opacity: 0,
            duration: 0
        }, {
            transform: `translate(0px, 0px)`,
            opacity: 1,
            duration: this.ANIMATION_DURATION_IN_SECONDS / 2,
        });

        /* Для центрального круга задаем active класс и и там появляется бутылочка */
        this.$circleCenterPoint.addClass(this.ACTIVE_CLASS);

        await AsyncHelper.delay(this.ANIMATION_DURATION_IN_SECONDS / 2, true);
    }

    /**
     * Задать анимацию на скрытие 5 экрана
     * @public
     */
    public async setHideScreenAnimation(): Promise<void> {
        /* Для центрального круга удаляем active класс и и там исчезает бутылочка */
        this.$circleCenterPoint.removeClass(this.ACTIVE_CLASS);

        /**
         * здесь мы двигаем $topContent и $bottomContent
         * по оси Y на 100px вниз,
         * и с opacity 1 по 0
         */
        gsap.to([
            this.$topContent,
            this.$bottomContent
        ], {
            transform: `translate(0px, ${100}px)`,
            opacity: 0,
            duration: this.ANIMATION_DURATION_IN_SECONDS
        });
        await AsyncHelper.delay(this.ANIMATION_DURATION_IN_SECONDS, true);
    }
}
